<template>
  <div v-if="courseProgress">
    <div class="w-75">
      <div class="progress-row">
        <div class="progress-bar-label">{{getProgressLabel}}%</div>
        <b-progress height="1.3rem" :precision="2" :max="courseProgress.childrenCount" style="background: #dd9623;">
          <b-progress-bar :value="attemptedValue" style="background: #0a7714;"></b-progress-bar>
        </b-progress>
      </div>
    </div>
    <div v-if="attemptedValue < courseProgress.childrenCount" style="margin-top: 10px;">
      <a href="javascript://" @click="launchCourse" style="color: #157099;">{{getLaunchCourseLabel}}</a>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'course-progress-bar',
    props: ['courseId'],
    data: () => {
      return {
        courseProgress: null
      }
    },
    mounted () {
      this.loadCourseProgress()
    },
    methods: {
      ...mapActions([
        'loadProgramCourseProgress'
      ]),
      async loadCourseProgress () {
        this.courseProgress = await this.loadProgramCourseProgress(this.courseId)
        if (!this.courseProgress.childrenCount) {
          this.courseProgress = {
            childrenCount: 1,
            childrenFailedCount: 0,
            childrenCompleteCount: 0,
            childrenInProgressCount: 0
          }
        }
      },
      launchCourse () {
        this.$emit('launchCourse', this.courseId)        
      }
    },
    computed: {
      getProgressLabel () {
        if (this.courseProgress) {
          if (this.attemptedValue > 0) {
            let progress = ((this.attemptedValue / this.courseProgress.childrenCount) * 100)
            if (Number.isInteger(progress)) {
              return progress
            }
            return progress.toFixed(2)
          }
          return 0
        }
        return 0
      },
      attemptedValue () {
        if (this.courseProgress) {
          return this.courseProgress.childrenCompleteCount + this.courseProgress.childrenInProgressCount + this.courseProgress.childrenFailedCount
        }
        return 0
      },
      getLaunchCourseLabel () {
        if (this.courseProgress) {
          return (this.attemptedValue > 0) ? 'continue learning' : 'start learning'
        }
        return 'start learning'
      }
    }
  }
</script>

<style scoped>
  .progress-row {
    width: 80%;
    position: relative;
  }
  .progress-bar-label {
    position: absolute;
    margin: auto;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    text-align: center;
    height: 22px;
    font-size: 14px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/app/transfer/components/CourseProgressBar.vue